import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function KeyValue(props) {
    const { label, value, link_btn } = props;
    return (
         <div className="pb-2 mb-1">
            <div>
                <small className="text-muted">{label}</small>
            </div>
            
            {link_btn ? 
                <Row>
                    <Col className="pr-0">
                        {value}
                    </Col>
                    <Col className="pl-0 text-right">
                        {React.cloneElement(link_btn, {className: `dt_link font-weight-bold ${link_btn.props.className || ""}` })}
                    </Col>
                </Row>
                : 
                <div>{value}</div>
            }
        </div>
    );
  }